module.exports = __webpack_public_path__ + "static/media/logo_blue_full_2025.08b9439d.png";